import { render } from "./MonochromePosterPage.vue?vue&type=template&id=31d4d4b2&scoped=true&ts=true"
import script from "./MonochromePosterPage.vue?vue&type=script&lang=ts"
export * from "./MonochromePosterPage.vue?vue&type=script&lang=ts"

import "./MonochromePosterPage.vue?vue&type=style&index=0&id=31d4d4b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d4d4b2"]])

export default __exports__